import CarAdvancedFilter from "./CarAdvancedFilter"

export default  CarAdvancedFilter;



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/CarAdvancedFilter/index.js